import * as React from 'react';
import { EventContentArg } from '@fullcalendar/core';

import { CalendarItem } from '../../../types';
import CalendarItemPickupMoment from './PickupMoment';
import CalendarItemHoliday from './Holiday';

import './style.scss';

const Item: React.FC<EventContentArg> = (props) => {
  const { event } = props;
  const startDate = event._instance?.range.start || new Date();
  const itemType = event._def.extendedProps.type as CalendarItem['type'];

  const dateLabel = new Intl.DateTimeFormat('nl-NL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(startDate);

  switch (itemType) {
    case 'pickupMoment': {
      const wasteStreamId = event._def.extendedProps.wasteStreamId as number;

      return (
        <CalendarItemPickupMoment
          title={event.title}
          dateLabel={dateLabel}
          wasteStreamId={wasteStreamId}
        />
      );
    }

    case 'holiday':
      return (
        <CalendarItemHoliday
          title={event.title}
          dateLabel={dateLabel}
        />
      );

    default:
      return null;
  }
};

export default Item;
